(function () {
  'use strict';

  /* @ngdoc object
   * @name slipAllowanceReport
   * @description
   *
   */
  angular
    .module('slipAllowanceReport', [
      'ui.router'
    ]);
}());
